import React, { useContext, useEffect, useMemo } from "react";
import HeaderComponent from "../../../components/header/header.component";
import { CaseProvider, GlobalContext } from "../../../store";
import { CommonService } from "../../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { CaseContentComponent } from "../../../modules/case/components/details/case-content/case-content.component";
import { history } from "react-router-guard";

interface CasePageProps {
  match: { params: { id: string } };
}

const CasePage: React.FC<CasePageProps> = ({ match }) => {
  const { t } = useTranslation();
  const { setPageTitle } = useContext(GlobalContext);
  const commonService = useMemo(() => new CommonService(), []);

  const caseIdParam = match.params.id;
  const caseId = caseIdParam ? parseInt(caseIdParam, 10) : NaN;
  const isValidId = Number.isInteger(caseId) && caseId > 0;

  useEffect(() => {
    if (!isValidId) return;
    const title = t("PAGE_META_TITLES.USE_CASE_MANAGER");
    commonService.setTitle(title);
    setPageTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidId, t, commonService]);

  if (!isValidId) {
    history.replace("/dashboard"); // or /ai-use-cases
    return null;
  }

  return (
    <CaseProvider>
      <HeaderComponent />
      <CaseContentComponent caseId={caseId} />
    </CaseProvider>
  );
};

export default CasePage;
